export default "---\ntitle: API Usage\n---\n\n# API Usage\n";